<script>
import router from '@/router'
export default {
  data() {
    return {
      
    }
  },
  methods: {
    nextClick(){
      router.push('/anim-one');
    }
    
  }
}
</script>

<template>
<header style="padding: 20px; display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
    <div>
    <h1>Experiment 1</h1>
    <p>The video below gives us an illustration of the scenario we will work across the experiments in this lab module.</p>
    </div>
  </header>

  <main class="flex-row">
  <div class = "codebox">
  
    <video height="400" controls autoplay="autoplay">
  <source src="..\assets\anim-one-a.mp4" type="video/mp4">
Your browser does not support the video tag.
</video>
 
  </div>
  <div class = "content">
    <h2>A Car Rental Management System.</h2>
    <p>Raj wants to go on a road trip from Delhi to Shimla. He plans to rent a car for the same. So, he uses the Vehicle booking system portal and selects 
       a car of his choice and registers himself by giving his personal details which include his name, phone no., email, etc.</p>
  </div>
</main>
<!-- eslint-disable-next-line vue/no-multiple-template-root-->
<footer>
    <div id="buttons" class="relative">
      <button class="navitem" @click="nextClick()">Next</button>
    </div>
  </footer>
</template>
  





<style>
 
 .codebox {
   height: 80%;
   width: 45%;
   padding: 25px;
   border-radius: 10px;
   background-color: #F9FAFE;
   box-shadow: 2px 3px 10px 2px #D7DFFF;
   overflow-x: hidden;
 }

 #buttons {
  margin: 0;
  text-align: center;
}

.relative {
  padding: 10px;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  background-color: #fff;
}

 .flex-row{
    display: flex;
    flex-direction: row;
    gap: 50px;
    margin: 20px;
    /* align-items: center; */
    background-color: #F9FAFE;
    justify-content: flex-start;
    min-height: 40vh;
 }

 .navitem {
  width: 100px;
  height: 50px;
  padding: 10px;
  text-align: center;
  border: none;
  background-color: #272971;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  font-weight: normal;
  font-size: large;
}

.navitem:hover {
  background-color: #fff;
  color: #272971;
  border: 1px solid #272971;
  cursor: pointer;
  font-weight: bold;
}


 .content{
    height: 80%;
    width: 45%;
    padding: 25px;
    border-radius: 10px;
    background-color: #F9FAFE;
    box-shadow: 2px 3px 10px 2px #D7DFFF;
    overflow-x: hidden;
 }

</style>